import { useEffect } from 'react';

let lockCount = 0;

const lockBodyScroll = () => {
   if (lockCount === 0) {
      document.body.style.overflow = 'hidden';
   }
   lockCount += 1;
};

const unlockBodyScroll = () => {
   lockCount = Math.max(0, lockCount - 1);
   if (lockCount === 0) {
      document.body.style.overflow = '';
   }
};

export const useBodyOverflowHidden = (isHidden = true, options = { disabled: false }) => {
   useEffect(() => {
      if (options.disabled) return undefined;
      if (isHidden) {
         lockBodyScroll();
         return () => {
            unlockBodyScroll();
         };
      }
      return undefined;
   }, [options, isHidden]);
};
